// School types and their grades, as a parent picks them (decision 0007). The
// ranges match internal/family/school.go; the server refuses any other pair.

import type { Child } from '../api/gen';

export type School = NonNullable<Child['school']>;

export const SCHOOLS: { value: School; label: string; first: number; last: number }[] = [
  { value: 'grundschule', label: 'Grundschule', first: 1, last: 4 },
  { value: 'mittelschule', label: 'Mittelschule', first: 5, last: 10 },
  { value: 'realschule', label: 'Realschule', first: 5, last: 10 },
  { value: 'gymnasium', label: 'Gymnasium', first: 5, last: 13 },
];

export function schoolLabel(school?: string | null): string {
  return SCHOOLS.find((s) => s.value === school)?.label ?? '';
}

/** The grades a school type has, as select options. */
export function gradeOptions(school: School): { value: string; label: string }[] {
  const s = SCHOOLS.find((x) => x.value === school)!;
  return Array.from({ length: s.last - s.first + 1 }, (_, i) => {
    const g = s.first + i;
    return { value: String(g), label: `Klasse ${g}` };
  });
}

/** "Gymnasium, Klasse 5", or what is known of it. */
export function schooling(c: Pick<Child, 'school' | 'grade'>): string {
  const parts = [schoolLabel(c.school), c.grade ? `Klasse ${c.grade}` : ''].filter(Boolean);
  return parts.join(', ');
}

/** A sensible first grade for a school type: the one a parent most often means. */
export function firstGrade(school: School): number {
  return SCHOOLS.find((s) => s.value === school)!.first === 1 ? 3 : 5;
}
